import React from "react";
import Text from "../../../components/Common/Text";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CustomInput from "../../../components/CustomForm/CustomInput";
import Pagination from "../../../components/CustomTable/Pagination";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";

const ProcedimientosModal = ({
  query,
  onQueryChange,
  columnsProcedimientos,
  dataProcedimientos,
  itemsPerPage,
  currentPage,
  handlePageChange,
  totalRegistros,
}) => {
  return (
    <div>
      <Text size="24px" isTittle={true} weight={"bold"}>
        {"Agregar Procedimiento"}
      </Text>

      <CustomInput
        type={"text"}
        placeholder={"Buscar"}
        value={query}
        onChange={onQueryChange()}
      />

      <CustomSeparator height={"10px"} />

      <CustomTable
        columns={columnsProcedimientos}
        dataSource={dataProcedimientos}
        showPagination={false}
        pageSize={itemsPerPage}
      />

      <CustomSeparator height={"20px"} />

      <Section>
        <Pagination
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          totalItems={totalRegistros || 0}
          onPageChange={handlePageChange}
        />
      </Section>
    </div>
  );
};

export default ProcedimientosModal;
